/**
 * Svelte action to add a highlight effect to an HTML element.
 *
 * This action creates and styles a `span` element that overlays the target
 * element with a highlight effect. The highlight style adapts based on the
 * width of the target element.
 *
 * Lifecycle functions:
 * - `update(newReactiveKey)`: Re-applies the highlight when the reactive key changes.
 * - `destroy()`: Removes the highlight when the element is destroyed or the action is removed.
 */
export function highlight(
  element: HTMLElement,
  _reactiveKey: any,
  background: string | undefined = "bg-widget-accent"
) {
  const span = document.createElement("span");

  function handleHighlight() {
    const elementWidth = element.getBoundingClientRect().width;
    span.classList.add(
      //if the element is larger than 300px, use different animation
      elementWidth > 300 ? "animate-smaller-ping" : "animate-small-ping",
      elementWidth > 300 ? "blur-md" : "blur-[2px]",
      elementWidth > 300 ? "opacity-20" : "opacity-45",
      elementWidth > 300 ? "dark:opacity-7" : "dark:opacity-15",
      background,
      "absolute",
      "inset-0",
      "inline-flex",
      "size-full",
      "min-w-4"
    );

    span.style.borderRadius = window.getComputedStyle(element).borderRadius;
    element.prepend(span);
  }

  return {
    update(newReactiveKey: any) {
      _reactiveKey = newReactiveKey;
      handleHighlight();
    },
    destroy() {
      span.remove();
    },
  };
}
